module.exports = __webpack_public_path__ + "static/img/yuqi-state3.5c52f900.png";